import { createApp } from 'vue';
import { vMaska } from 'maska';
import { createPinia } from 'pinia';
import { controllerModel, BottomSheetPlugin } from 'shared';

import { debugEntity } from '../entities/debug-entity';
import { use5Clicks } from '../entities/use-5-clicks';
import { initInterceptor } from '../features/network-interceptor';
import DebugBar from './index.vue';

declare global {
  interface Window {
    isPiniaInitialized: boolean;
  }
}

const mountDebugBar = () => {
  const app = createApp(DebugBar);

  if (!window.isPiniaInitialized) {
    app.use(createPinia());
  }

  const mountElem = document.createElement('div');
  mountElem.id = 'debug-bar';

  document.body.appendChild(mountElem);

  app
    .use(BottomSheetPlugin, {
      controllerInjectionKey:
        controllerModel.injectionSymbols.BOTTOM_SHEET_CONTROLLER_SYMBOL,
    })
    .directive('maska', vMaska)
    .mount('#debug-bar');
};

// TODO: Move to a separate project?
/**
 * Method to append a debug bar to a page. Should be used only in DEV/STAGE modes
 */
const init = () => {
  const debugBar = debugEntity.model.useDebugState();

  if (debugBar.state.value.isDebugBarVisible) {
    mountDebugBar();
    initInterceptor();
  } else {
    // eslint-disable-next-line no-console
    console.log(
      '[DebugBar]: Debug bar is hidden\nTo show it you need to click at any space 5 times in 1 second or add the "isDebugBarVisible=true" search query parameter',
    );

    const clicksHandler = use5Clicks();

    document.addEventListener('click', function handle5Clicks() {
      clicksHandler.onClick(() => {
        /**
         * Need to remove event listener when debug bar is mounted,
         * since we don't need to open it again
         */
        document.removeEventListener('click', handle5Clicks);
        debugBar.updateState({ isDebugBarVisible: true });
      });
    });
  }
};

export const debugBar = { init };
export { debugEntity } from '../entities/debug-entity';
